import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import * as AdminActions from "../../../../actions/admin";
import * as RaceActions from "../../../../actions/race";
import {CompressList, removeCommaWhitespace, removeNonDigits} from "../../../../../../common/src/util/lib";
import {confirm} from "../../../../utils/confirmDialog";
import {NotificationManager} from "react-notifications";
import {push, replace} from "react-router-redux";
import {ROUTE_CHAMPIONSHIP, ROUTE_CLUB} from "../../../../constants/routeconstants";

export const defaultState = {
    Ringnummer: ''
};

class ChampionshipPigeons extends React.Component {

    static propTypes = {
        editMode: PropTypes.bool,
        championship: PropTypes.object.isRequired,
    };

    static defaultProps = {
        editMode: false,
    };

    constructor(props) {
        super(props);
        this.state = defaultState
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.editMode || ((nextProps.championship === null && this.props.championship !== null) || (nextProps.championship !== null && (this.props.championship === null || this.props.championship.RecNr !== nextProps.championship.RecNr)))) this.setState(defaultState);
    }

    fields = [];

    render() {
        if (!this.props.championship) return null;

        const editMode = this.props.editMode;

        let pigeonRows = []

        this.props.championship.MesterskabDues.sort((p1, p2) => {
            if (p1.Ringnummer < p2.Ringnummer) return -1;
            if (p1.Ringnummer > p2.Ringnummer) return 1;
            return 0;
        }).forEach(pigeon => {
            pigeonRows.push(
                <tr key={pigeon.Ringnummer} id={'pigeon-row-' + pigeon.Ringnummer}>
                    <td>{pigeon.Ringnummer}</td>
                    <td>{
                        <i key={0}
                           className={"fa fa-trash "} title="Slet fra mesterskab" onClick={() => {
                            confirm("Slet",
                                <span>Ønsker du at fjerne ringnummeret <b>{pigeon.Ringnummer}</b> fra mesterskabet?</span>, () => {
                                    this.props.dispatch(AdminActions.deleteChampionshipPigeon(this.props.championship.RecNr, pigeon.Ringnummer, () => {
                                        NotificationManager.success(`Ringnummeret ${pigeon.Ringnummer} er slettet fra mesterskabet`, "Sletning", 4000);
                                    }));
                                });
                        }}/>
                    }</td>
                </tr>
            )
        })

        return <div
            className={"form-page championship-basics championship-pigeons " + (editMode ? "editable" : "read-only")}>
            <div className={'championship-pigeons-container'}>
                <div className={'content left-content'}>
                    <div className={'block-content left-block'}>
                        <label>Ringnummer</label>
                        <div className={'form'}>
                            <UserFieldElement
                                dataType={UserFieldDataType.regex}
                                placeholder=""
                                className="field150"
                                containerClassName="display-inline-block"
                                name="Ringnummer"
                                id="Ringnummer"
                                maxLength="11"
                                options={[
                                    {
                                        key: UserFieldDataType.regex.REGEX_OPTION_KEY,
                                        value: "[0-9]{3}\\-[0-9]{2}\\-[0-9]{4}"
                                    }
                                ]}
                                value={this.state.Ringnummer}
                                autoCheckErrors={true}
                                required={true}
                                hideErrWhenFocused={true}
                                hideErrUntilFocused={true}
                                onChange={this.onRingNumberChange}
                                ref={instance => {
                                    this.fields[0] = instance;
                                }}
                            />
                            <button className="btn-primary" title="Tilføj ringnummer" onClick={this.save}>Tilføj</button>
                        </div>

                        <div className={'button-container'}>
                            <button className="btn-primary" title="Slet alle ringnumre" onClick={this.deleteAll}>Slet
                                alle
                            </button>
                        </div>
                    </div>
                </div>
                {pigeonRows.length ? <div className={'outer-content'}>
                    <div className={'inner-content'}>
                        <table className="data-table">
                            <thead>
                            <tr>
                                <th>Deltagende ringnumre</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {pigeonRows}
                            </tbody>
                        </table>
                    </div>
                </div>: null}
            </div>
        </div>
    }

    onRingNumberChange = (e) => {
        const string = /^[0-9]{9}$/.test(e.target.value) ? e.target.value.substr(0, 3) + '-' + e.target.value.substr(3, 2) + '-' + e.target.value.substr(5, 4) : e.target.value
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: string});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    save = () => {
        if (this.allInputValid()) {
            const entity = {
                Ringnummer: this.state.Ringnummer === '' ? null : this.state.Ringnummer,
            };
            this.props.dispatch(AdminActions.createChampionshipPigeon(this.props.championship.RecNr, entity, () => {
                this.fields[0].setState({focused: false, visited: false});
                NotificationManager.success(`Ringnummeret ${entity.Ringnummer} er tilmeldt mesterskabet.`, "Oprettelse", 4000);
                setTimeout(function () {
                    const currentRow = document.getElementById('pigeon-row-' + entity.Ringnummer);
                    currentRow.scrollIntoView(false);
                });
            }))
        } else {
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }
    }

    deleteAll = () => {
        confirm("Slet", <span>Ønsker du at slette alle ringnumre fra mesterskabet?</span>, () => {
            this.props.dispatch(AdminActions.deleteChampionshipPigeons(this.props.championship.RecNr, () => {
                NotificationManager.success(`Ringnumre er slettet fra mesterskabet`, "Sletning", 4000);
            }));
        });
    }
}

const mapStateToProps = (state) => ({
    race: {
        isRacesRead: state.race.isRacesRead,
        races: state.race.races
    }
});

export default connect(mapStateToProps, null, null, {withRef: true})(ChampionshipPigeons);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/championships/subPages/ChampionshipPigeons.js